import React from "react";
import { FormField, Form, Checkbox } from "semantic-ui-react";
import styles from "../style/Properties.module.css";
import GlobalTextInputField from "../../Components/Inputs/GlobalTextInputField";
import Localize from "react-intl-universal";

const DunningForm = props => {
  const {
    currentItem,
    setCurrentItem,
    setEditedFields,
    editedFields,
    parameters,
    availableItemFieldsForDetails
  } = props;

  const findProperty = propertyName => {
    let tempItem = currentItem.find(item => item.name === propertyName);
    return tempItem ? tempItem.value : "";
  };

  const sortedCurrentItems = availableItemFieldsForDetails.map(item =>
    currentItem.find(el => el.name === item.name)
  );

  const changeInputField = (e, data) => {
    let myIndex = sortedCurrentItems.findIndex(item => item.name === data.name);
    const setFields = editedItemId => {
      if (!editedFields.includes(editedItemId)) {
        let tempArray = editedFields;
        tempArray.push(editedItemId);
        setEditedFields(tempArray);
      }
    };

    let tempItem = sortedCurrentItems.map((item, index) => {
      if (item.name === data.name) {
        setFields(item.id);
        return {
          ...item,
          value: data.type === "text" || data.type === "password" ? data.value : data.checked
        };
      }
      if (currentItem[0].subcategory.subcategoryName === "dunning_phases") {
        if (data.checked) {
          if (index < myIndex) {
            setFields(item.id);
            return {
              ...item,
              value: true
            };
          }
        } else if (index > myIndex) {
          setFields(item.id);
          return {
            ...item,
            value: false
          };
        }
      }
      return item;
    });

    setCurrentItem(tempItem);
  };

  const getProperties = () => {
    return availableItemFieldsForDetails.map((field, index) => {
      let propertyValue = findProperty(field.name);
      if (field.type === "boolean") {
        return (
          <FormField key={index} required={false}>
            <label>{Localize.get(field.hederName)}</label>
            <Checkbox
              name={field.name}
              checked={propertyValue === "true" || propertyValue === true}
              toggle
              onChange={changeInputField}
            />
          </FormField>
        );
      } else {
        return (
          <GlobalTextInputField
            key={index}
            labelName={field.hederName}
            inputName={field.name}
            itemValue={propertyValue}
            isRequired={field.isRequired}
            onInputChange={changeInputField}
            errorFields={parameters}
            inputDisabled={field.inputDisabled}
            inputType={field.type}
          />
        );
      }
    });
  };

  return (
    <>
      <div className={styles.form_container}>
        <Form>{getProperties()}</Form>
      </div>
    </>
  );
};

export default DunningForm;
